export default __webpack_public_path__ + "static/media/art-apt.0d8f99ac.jpg";